export const YES_FLAG = 'Y';
export const NO_FLAG = 'N';

export const DEFAULT_TRADING_PARTNER = '0000';

export const adjustmentTypes = {
  PERM: 'P',
  TEMP: 'T',
  TAX_CREDIT: 'TAXCREDIT',
  GAAP_TO_STAT_REVERSING: 'O',
  GAAP_TO_STAT_NON_REVERSING: 'G',
  STATE_PERM_MODS: 'M',
  STATE_TEMP_MODS: 'N',
  STATE_ADJUSTMENT: 'S',
  PRE_TAX_ADJUSTMENT: 'B',
  PRIOR_CREDIT_UTILIZATION: 'DTAXCREDIT',
};

export const statusBadgeMessages = {
  CALCULATED: 'Calculated',
  COMPLETE: 'Complete',
  IN_PROCESS: 'In Process',
  NOT_STARTED: 'Not Started',
  PROCESSING: 'Processing...',
  PROCESSING_COMPLETE: 'Processing Complete',
  PENDING: 'Pending',
  ERROR: 'Error',
  UPDATED: 'Updated',
};

export const connectionStatuses = {
  NOT_STARTED: -1,
  PROCESSING: 0,
  PROCESSING_COMPLETE: 1,
  UPDATED: 4,
};

export const paramSyntaxInCustomReport = /'&(.*?)'/g;

export const US_COUNTRY_TAX_TYPE_REGEX = /^US-[A-Z]{2}\d$/;

export const countryTaxTypes = {
  US1: 'US-US1',
  US2: 'US-US2',
  XX1: 'xx-xx1',
};

export const countryTaxTypesViewOnlyOptions = {
  'US-USX': true, // US FBOS and Federal
  'US-USY': true, // US FBOS, Federal and State
  'US-USZ': true, // All States
  'ALL-ALL': true, // All Country Taxes
};

export const US_COUNTRY_TAX_TYPES = {
  US_FEDERAL_INCOME_TAX: 'US2',
  US_STATE_INCOME_TAX: 'US1',
  US_FBOS: 'US3',
};

export enum exceptionBasisTypes {
  S = 'S',
  C = 'C',
  P = 'P',
  T = 'T',
  O = 'O',
  G = 'G',
  M = 'M',
  N = 'N',
  D = 'D'
}

export const exceptionBasisDescriptions = {
  S: 'S - State Adjustment',
  C: 'C - After Tax Adjustment',
  P: 'P - Perm',
  T: 'T - Temp',
  O: 'O - GAAP to STAT Reversing',
  G: 'G - GAAP to STAT Non-Reversing',
  M: 'M - State Perm Mod',
  N: 'N - State Temp Mod',
  D: 'D - Prior Credit Utilization',
};

export const exceptionBases = {
  US_FEDERAL: [
    { value: exceptionBasisTypes.S, label: exceptionBasisDescriptions.S },
    { value: exceptionBasisTypes.P, label: exceptionBasisDescriptions.P },
    { value: exceptionBasisTypes.T, label: exceptionBasisDescriptions.T },
    { value: exceptionBasisTypes.C, label: exceptionBasisDescriptions.C },
    { value: exceptionBasisTypes.D, label: exceptionBasisDescriptions.D },
  ],
  US_STATE: [
    { value: exceptionBasisTypes.M, label: exceptionBasisDescriptions.M },
    { value: exceptionBasisTypes.N, label: exceptionBasisDescriptions.N },
    { value: exceptionBasisTypes.C, label: exceptionBasisDescriptions.C },
    { value: exceptionBasisTypes.D, label: exceptionBasisDescriptions.D },
  ],
  NON_US: [
    { value: exceptionBasisTypes.O, label: exceptionBasisDescriptions.O },
    { value: exceptionBasisTypes.G, label: exceptionBasisDescriptions.G },
    { value: exceptionBasisTypes.P, label: exceptionBasisDescriptions.P },
    { value: exceptionBasisTypes.T, label: exceptionBasisDescriptions.T },
    { value: exceptionBasisTypes.C, label: exceptionBasisDescriptions.C },
    { value: exceptionBasisTypes.D, label: exceptionBasisDescriptions.D },
  ],
  ALL: [
    { value: exceptionBasisTypes.S, label: exceptionBasisDescriptions.S },
    { value: exceptionBasisTypes.P, label: exceptionBasisDescriptions.P },
    { value: exceptionBasisTypes.T, label: exceptionBasisDescriptions.T },
    { value: exceptionBasisTypes.C, label: exceptionBasisDescriptions.C },
    { value: exceptionBasisTypes.M, label: exceptionBasisDescriptions.M },
    { value: exceptionBasisTypes.N, label: exceptionBasisDescriptions.N },
    { value: exceptionBasisTypes.O, label: exceptionBasisDescriptions.O },
    { value: exceptionBasisTypes.G, label: exceptionBasisDescriptions.G },
    { value: exceptionBasisTypes.D, label: exceptionBasisDescriptions.D },
  ],
};

export const YNOptions = {
  Y: 'Y',
  N: 'N',
};

export const COMPANY_SOURCES = {
  GLDRPT: 'GLDRPT',
  TLS: 'TLS',
};

export const ALL_OPTION = 'ALL';

export const TBE_TYPES = {
  US_TBE: 'US_TBE',
};

export const TAX_CURRENCIES = {
  USD: 'USD',
};

export enum METHODS {
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
}

export const SESSION_EXPIRE_WARNING_TIME = 60; // seconds
export const SESSION_EXPIRE_NORMAL_REFRESH_TIME = 20000; // ms
export const SESSION_EXPIRE_WARNING_REFRESH_TIME = 3000; // ms

export const IDLE_PROCESS_REFRESH_TIME = 30000; // ms

export const maintenanceErrorMessage = 'maintenance';
export const clientDisabledErrorMessage = 'disabled';

export enum CountryTaxTypeStaticOptions {
  NONE = 'NONE',
  FBOS = 'FBOS',
  ALL = 'ALL'
}
